export const vocabularyCs = {
    'Nalezeno': [
        'Nalezeno',
        'Nalezen',
        'Nalezeny',
    ],
    'vysledku': [
        'výsledků',
        'výsledek',
        'výsledky',
    ],
};
